import React from 'react';
import MuiAutocomplete from '@material-ui/lab/Autocomplete';
import MuiPaper from '@material-ui/core/Paper';
import UnfoldMoreOutlinedIcon from '@material-ui/icons/UnfoldMoreOutlined';
import type { PaperProps } from '@material-ui/core/Paper';
import type { AutocompleteProps as MuiProps } from '@material-ui/lab/Autocomplete';

const PaperComponent = ({ children }: PaperProps) => (
    <MuiPaper elevation={0} variant="outlined">
        {children}
    </MuiPaper>
);

export type AutocompleteProps<
    T,
    Multiple extends boolean | undefined,
    DisableClearable extends boolean | undefined,
    FreeSolo extends boolean | undefined,
> = MuiProps<T, Multiple, DisableClearable, FreeSolo>;

function Autocomplete<
    T,
    Multiple extends boolean | undefined,
    DisableClearable extends boolean | undefined,
    FreeSolo extends boolean | undefined,
>(props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>): JSX.Element {
    return <MuiAutocomplete PaperComponent={PaperComponent} popupIcon={<UnfoldMoreOutlinedIcon />} {...props} />;
}

export default Autocomplete;
